import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Form } from 'redux-form'
import { connect } from 'react-redux'
import classNames from 'classnames/bind'
import { get, noop } from 'lodash'
import { SimpleTitle } from '../title'
import {
  HIDDEN_FIELD_NAME,
  FORM_NAME as ENTITY_FORM_NAME,
} from './shared/constants'
import {
  rules as EntityFormRules,
  rulesType,
  closeOtherContent,
} from './shared/internal'
import InterestedPartyForm from './shared/interestedPartyForm'
import styles from './styles.scss'
const cx = classNames.bind(styles)

class EntityForm extends Component {
  static propTypes = {
    isAutoCapitalize: PropTypes.bool,
    isOhioAsset: PropTypes.bool,
    disableParentTitle: PropTypes.bool,
    ...rulesType,
  }

  constructor(props) {
    super(props)
    this.state = {
      showTitlesOnly: false,
      title: props.title,
      contentOpened: {},
      disableParentTitle: false,
    }
  }

  onTitleChange = (_, newTitle) => {
    this.setState({ title: newTitle })
  }

  updateContentOpened = (key, value, closeOthers) => {
    let { contentOpened } = this.state

    if (closeOthers) {
      contentOpened = closeOtherContent(contentOpened, key)
    }

    contentOpened[key] = value
    this.setState({
      contentOpened,
    })
  }

  deleteContentOpenedKey = key => {
    const { contentOpened } = this.state
    delete contentOpened[key]

    this.setState({
      contentOpened,
    })
  }

  componentDidUpdate(prevProp, prevState) {
    if (prevState.title !== this.props.title) {
      this.onTitleChange(noop, this.props.title)
    }
  }

  render() {
    const { title, contentOpened } = this.state

    const {
      rules,
      formValues,
      submitFailed,
      parentEntityError,
      isAutoCapitalize,
      isOhioAsset,
      disableParentTitle,
    } = this.props
    const fieldValues = get(formValues, ENTITY_FORM_NAME, {})
    return (
      <div className={cx('root')}>
        <SimpleTitle title={title} />
        <div className={cx('content')}>
          <Form onSubmit={noop}>
            <div className={cx('parent-entity')}>
              <InterestedPartyForm
                isRootParent
                rules={rules}
                formKey='parent'
                fieldValues={fieldValues}
                onTitleChange={this.onTitleChange}
                parentEntityError={parentEntityError}
                meta={{ submitFailed }}
                isAutoCapitalize={isAutoCapitalize}
                isOhioAsset={isOhioAsset}
                disableParentTitle={disableParentTitle}
                contentOpenedContext={{
                  contentOpened,
                  updateContentOpened: this.updateContentOpened,
                  deleteKey: this.deleteContentOpenedKey,
                }}
              />
            </div>
          </Form>
        </div>
      </div>
    )
  }
}

export default connect((state, props) => {
  return {
    submitFailed: get(state, `form.${ENTITY_FORM_NAME}.submitFailed`),
    parentEntityError: get(
      state,
      `form.${ENTITY_FORM_NAME}.syncErrors.${HIDDEN_FIELD_NAME}`
    ),
    title: get(state, `form.${ENTITY_FORM_NAME}.values.parent.entityName`, ''),
  }
})(EntityForm)
export { ENTITY_FORM_NAME, EntityFormRules }
